import { jsx as o } from "react/jsx-runtime";
const l = ({ size: C = 24, color: t = "currentColor", ...r }) => /* @__PURE__ */ o(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: C,
    height: C,
    viewBox: "0 0 24 24",
    fill: "none",
    ...r,
    children: /* @__PURE__ */ o(
      "path",
      {
        d: "M17.5133 5.28976C17.5133 5.28976 18.1083 5.87309 17.5133 5.28976C16.7158 4.37931 16.2763 3.21009 16.2767 1.99976H12.6717V16.4664C12.6439 17.2493 12.3133 17.9908 11.7497 18.5348C11.1861 19.0789 10.4334 19.383 9.65 19.3831C7.99333 19.3831 6.61667 18.0298 6.61667 16.3498C6.61667 14.3431 8.55333 12.8381 10.5483 13.4564V9.76976C6.52333 9.23309 3 12.3598 3 16.3498C3 20.2348 6.22 22.9998 9.63833 22.9998C13.3017 22.9998 16.2767 20.0248 16.2767 16.3498V9.01142C17.7385 10.0612 19.4936 10.6245 21.2933 10.6214V7.01642C21.2933 7.01642 19.1 7.12142 17.5133 5.28976Z",
        fill: t
      }
    )
  }
);
export {
  l as TikTokIcon
};
